import { render } from "./MobileLoginPage.vue?vue&type=template&id=a1d8a408&scoped=true"
import script from "./MobileLoginPage.vue?vue&type=script&lang=js"
export * from "./MobileLoginPage.vue?vue&type=script&lang=js"

import "./MobileLoginPage.vue?vue&type=style&index=0&id=a1d8a408&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1d8a408"]])

export default __exports__